import React from 'react';
import { Link } from 'react-router-dom';

// Custom Monti wordmark. `division` switches the wordmark & sublabel.
export default function Logo({ variant = 'dark', division = 'homepros', className = '' }) {
  const wordColor = variant === 'light' ? '#FBFDFD' : '#213739';
  const subColor = variant === 'light' ? '#D6E8E5' : '#5E9A93';
  const isFloors = division === 'floors';
  const word = isFloors ? 'Monti Floors' : 'Monti Home Pros';
  const sub = isFloors ? 'Mobile Showroom' : 'Your Home, Handled';
  const to = isFloors ? '/floors' : '/';

  return (
    <Link to={to} className={`flex items-center gap-2.5 group ${className}`} aria-label={`${word} home`}>
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" className="shrink-0">
        <rect x="2" y="2" width="30" height="30" rx="7" fill="#0F9488" />
        {isFloors ? (
          <g className="origin-center transition-transform duration-500 group-hover:rotate-3">
            <rect x="8" y="10" width="18" height="3.4" rx="1.2" fill="#FBFDFD" />
            <rect x="8" y="15.3" width="12" height="3.4" rx="1.2" fill="#ECF5F3" opacity="0.85" />
            <rect x="8" y="20.6" width="18" height="3.4" rx="1.2" fill="#FBFDFD" />
          </g>
        ) : (
          <g className="origin-center transition-transform duration-500 group-hover:-translate-y-[1px]">
            <path d="M17 8.5 L25.5 15 V25 H8.5 V15 Z" fill="none" stroke="#FBFDFD" strokeWidth="2.2" strokeLinejoin="round" />
            <rect x="14.6" y="18.5" width="4.8" height="6.5" rx="0.6" fill="#ECF5F3" />
          </g>
        )}
      </svg>
      <span className="flex flex-col leading-none">
        <span className="font-display text-[21px] font-semibold tracking-tight" style={{ color: wordColor }}>
          {word}
        </span>
        <span className="text-[9px] uppercase tracking-[0.26em] font-medium mt-0.5" style={{ color: subColor }}>
          {sub}
        </span>
      </span>
    </Link>
  );
}
